// extracted by mini-css-extract-plugin
export default {"this":"Link_this__T69P-","description":"Link_description__YZ45E","line":"Link_line__4BnLZ","text":"Link_text__C5sYL"};